import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MyInfo } from '../../types/authData';

export interface AuthState {
  isLogin: boolean;
  myInfo: MyInfo | undefined;
}

const initialState: AuthState = {
  isLogin: false,
  myInfo: undefined,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action: PayloadAction<any>) {
      state.isLogin = true;
      state.myInfo = action.payload;
    },
    logout(state) {
      state.isLogin = false;
      state.myInfo = undefined;
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice;
